import { useShowContext } from 'framework/show';
import { WorkingCondition, EMPLOYEE_CONTRACT_TYPES, RELOCATION_OPTION } from 'domain/shared/newVacancy';
import { Box } from '@mui/material';
import { EnumField, ListField, TextField } from 'framework/ui/field';
import { EMPLOYEE_CONTRACT_ASSIGMENT_TYPES } from 'domain/shared/employee';
import OfficeAndAccommodationIcons from '../../shared/OfficeAndAccommodationIcons';
import { SwiperContainer } from 'framework/ui/ui-builder';

const WorkingConditionsSwiper = () => {
  const { data } = useShowContext();
  const { workingConditions } = data.getData();

  return (
    <SwiperContainer>
      {workingConditions.map((workingCondition: WorkingCondition & { id: string }) => {
        const [office, accommodation] = workingCondition.hiringLocation.split('_', 2);

        return (
          <Box sx={{ height: '195px' }}>
            <Box
              sx={{
                mb: '20px',
                display: 'flex',
              }}
            >
              <Box
                sx={{
                  flexBasis: '33%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <OfficeAndAccommodationIcons registrations={[office]} accommodations={[accommodation]} />
              </Box>

              <Box
                sx={{
                  flexBasis: '33%',
                }}
              >
                <TextField label="Compensation" value={workingCondition.compensationValue} />
              </Box>

              <EnumField
                options={RELOCATION_OPTION}
                value={workingCondition.isRelocationAvailable as any}
                label="Relocation"
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
              }}
            >
              <Box
                sx={{
                  flexBasis: '33%',
                }}
              >
                <ListField value={workingCondition.employmentTypes as any} label="Employment type">
                  <EnumField options={EMPLOYEE_CONTRACT_ASSIGMENT_TYPES} />
                </ListField>
              </Box>

              <ListField value={workingCondition.contractTypes as any} label="Contract type">
                <EnumField options={EMPLOYEE_CONTRACT_TYPES} />
              </ListField>
            </Box>
          </Box>
        );
      })}
    </SwiperContainer>
  );
};

export default WorkingConditionsSwiper;
